export const quoteTranslations = {
  en: {
    quote: {
      section_title: 'CBM Calculator & Shipping Quote',
      section_subtitle: 'Calculate your cargo volume and request an optimized LCL rate',
      // Calculator
      calc_title: 'CBM Volume Calculator',
      calc_subtitle: 'Enter your package dimensions to calculate total shipping volume',
      length: 'Length',
      width: 'Width',
      height: 'Height',
      quantity: 'Quantity',
      unit_cm: 'cm',
      description: 'Package Description',
      description_placeholder: 'e.g., Cardboard box #1',
      weight_per_unit: 'Weight per unit',
      unit_kg: 'kg',
      add_package: 'Add Another Package',
      remove: 'Remove',
      total_cbm: 'Total Volume',
      total_weight: 'Total Weight',
      packages: 'packages',
      use_in_quote: 'Values auto-filled into the quote form below',
      // Quote form (user spec)
      title: 'Request a Shipping Quote',
      subtitle: 'Fill out the details below, and our logistics experts will get back to you with an optimized LCL rate.',
      // Contact (required for us to reach back)
      name: 'Full Name',
      email: 'Email Address',
      phone: 'Phone Number',
      company: 'Company Name (Optional)',
      // Shipment
      commodityType: 'Commodity Type',
      commodityPlaceholder: 'e.g., Apparel, Footwear, Electronics, Building Materials',
      weight: 'Total Weight (kg)',
      volume: 'Total Volume (CBM)',
      origin: 'Port of Loading (Origin)',
      originPlaceholder: 'e.g., Shanghai, China',
      destination: 'Port of Discharge',
      destinationValue: 'Latakia Port, Syria',
      customsClearance: 'Do you require customs clearance in Latakia?',
      yes: 'Yes, include customs clearance',
      no: 'No, shipping only',
      // Actions
      submit: 'Submit Quote Request',
      submitting: 'Submitting...',
      successMessage: 'Thank you! Your request has been received. Our team in Latakia will contact you shortly.',
      error: 'Something went wrong. Please try again or contact us via WhatsApp.',
    }
  },
  ar: {
    quote: {
      section_title: 'حاسبة الحجم وطلب تسعير الشحن',
      section_subtitle: 'احسب حجم شحنتك واحصل على أفضل سعر شحن جزئي',
      calc_title: 'حاسبة الحجم بالمتر المكعب',
      calc_subtitle: 'أدخل أبعاد الطرود لحساب الحجم الإجمالي للشحن',
      length: 'الطول',
      width: 'العرض',
      height: 'الارتفاع',
      quantity: 'الكمية',
      unit_cm: 'سم',
      description: 'وصف الطرد',
      description_placeholder: 'مثال: صندوق كرتون رقم 1',
      weight_per_unit: 'الوزن للوحدة',
      unit_kg: 'كغ',
      add_package: 'إضافة طرد آخر',
      remove: 'إزالة',
      total_cbm: 'الحجم الإجمالي',
      total_weight: 'الوزن الإجمالي',
      packages: 'طرود',
      use_in_quote: 'يتم تعبئة القيم تلقائياً في نموذج التسعيرة أدناه',
      title: 'طلب تسعير شحنة',
      subtitle: 'أدخل تفاصيل شحنتك، وسيقوم خبراؤنا اللوجستيون بتزويدك بأفضل سعر للشحن الجزئي.',
      name: 'الاسم الكامل',
      email: 'البريد الإلكتروني',
      phone: 'رقم الهاتف',
      company: 'اسم الشركة (اختياري)',
      commodityType: 'نوع البضاعة',
      commodityPlaceholder: 'مثال: ألبسة، أحذية، إلكترونيات، مواد بناء',
      weight: 'الوزن الإجمالي (كغ)',
      volume: 'الحجم الإجمالي (CBM - متر مكعب)',
      origin: 'ميناء الشحن (المنشأ)',
      originPlaceholder: 'مثال: شنغهاي، الصين',
      destination: 'ميناء الوصول',
      destinationValue: 'مرفأ اللاذقية، سوريا',
      customsClearance: 'هل تحتاج إلى تخليص جمركي في اللاذقية؟',
      yes: 'نعم، أريد الشحن مع التخليص الجمركي',
      no: 'لا، شحن فقط',
      submit: 'إرسال طلب التسعيرة',
      submitting: 'جاري الإرسال...',
      successMessage: 'شكراً لك! تم استلام طلبك بنجاح. سيتواصل معك فريقنا في اللاذقية قريباً.',
      error: 'حدث خطأ. يرجى المحاولة مرة أخرى أو التواصل عبر واتساب.',
    }
  },
  tr: {
    quote: {
      section_title: 'CBM Hesaplayıcı ve Nakliye Teklifi',
      section_subtitle: 'Yük hacminizi hesaplayın ve optimize edilmiş LCL teklifi alın',
      calc_title: 'CBM Hacim Hesaplayıcı',
      calc_subtitle: 'Toplam nakliye hacmini hesaplamak için paket boyutlarınızı girin',
      length: 'Uzunluk',
      width: 'Genişlik',
      height: 'Yükseklik',
      quantity: 'Adet',
      unit_cm: 'cm',
      description: 'Paket Açıklaması',
      description_placeholder: 'Örn: Karton kutu #1',
      weight_per_unit: 'Birim Ağırlık',
      unit_kg: 'kg',
      add_package: 'Başka Paket Ekle',
      remove: 'Kaldır',
      total_cbm: 'Toplam Hacim',
      total_weight: 'Toplam Ağırlık',
      packages: 'paket',
      use_in_quote: 'Değerler aşağıdaki teklif formuna otomatik doldurulur',
      title: 'Nakliye Teklifi Talep Edin',
      subtitle: 'Aşağıdaki detayları doldurun, lojistik uzmanlarımız size optimize edilmiş bir LCL fiyatıyla dönüş yapacak.',
      name: 'Ad Soyad',
      email: 'E-posta Adresi',
      phone: 'Telefon Numarası',
      company: 'Şirket Adı (İsteğe Bağlı)',
      commodityType: 'Emtia Türü',
      commodityPlaceholder: 'Örn: Giyim, Ayakkabı, Elektronik, İnşaat Malzemesi',
      weight: 'Toplam Ağırlık (kg)',
      volume: 'Toplam Hacim (CBM)',
      origin: 'Yükleme Limanı (Menşe)',
      originPlaceholder: 'Örn: Shanghai, Çin',
      destination: 'Tahliye Limanı',
      destinationValue: 'Latakya Limanı, Suriye',
      customsClearance: 'Latakya\'da gümrük işlemlerine ihtiyacınız var mı?',
      yes: 'Evet, gümrük işlemlerini dahil edin',
      no: 'Hayır, sadece nakliye',
      submit: 'Teklif Talebi Gönder',
      submitting: 'Gönderiliyor...',
      successMessage: 'Teşekkürler! Talebiniz alındı. Latakya\'daki ekibimiz kısa süre içinde sizinle iletişime geçecek.',
      error: 'Bir hata oluştu. Lütfen tekrar deneyin veya WhatsApp\'tan bize ulaşın.',
    }
  }
};
